var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-t my-1 border-color-gray-200 "})}
var staticRenderFns = []

export { render, staticRenderFns }